<template>
  <div class="records">
    <div class="order-list" v-show="orderRecords.length">
      <list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="sku-details" v-for="(sku, index) in orderRecords" :key="index">
          <div class="service-ticket">
            <button class="service-number">服务单号：{{sku.trade_id}}</button>
          </div>
          <a href="javascript:;" class="jump-details" @click="goDetails(sku.serial_no)">
            <div class="sku-img">
              <img v-lazy="sku.pic_url" />
            </div>
            <div class="sku-desc">
              <div class="sku-intro">
                <div class="sku-title">{{sku.name}}</div>
                <div class="sku-name-num">
                  <div class="sku-name">
                    <span>
                      <em
                        v-for="(attr, index) in sku.attr_list"
                        :key="index"
                      >{{attr.attr_value.value}}</em>
                    </span>
                  </div>
                  <div class="sku-num">数量: {{sku.number}}</div>
                </div>
                <div class="sku-platform">{{sku.platform_info.brand}}</div>
              </div>
            </div>
          </a>
          <div class="service-status">{{statusText(sku.status)}}</div>
        </div>
      </list>
    </div>
    <no-data v-show="noData && !orderRecords.lnegth"></no-data>
  </div>
</template>

<script>
import { List } from 'vant'
import NoData from './NoData'
let flag = false
export default {
  name: 'records',
  components: {
    List,
    NoData
  },
  data () {
    return {
      loading: false,
      finished: false,
      noData: false,
      orderRecords: [],
      pageNum: 1
    }
  },
  computed: {
    statusText (status) {
      return (status) => {
        switch (status) {
          case 10 :
            return '待审核'
          case 20:
            return '审核不通过'
          case 30:
            return '待寄回'
          case 31:
            return '上门取件'
          case 40:
            return '已寄送'
          case 50:
            return '商家已收货'
          case 60:
            return '退款成功'
          case 61:
            return '退款成功'
          case 70 :
            return '已取消'
          case 90:
            return '完成'
          default:
            return '审核中'
        }
      }
    }
  },
  created () {
    this.$toast.loading('加载中....')
    this.getOrderList(this.pageNum).then(() => {
      this.$toast.clear()
    })
  },
  methods: {
    /**
     * 查看服务单
     */
    async goDetails (refId) {
      // await this.getRefIdHandler({ refId })
      this.$router.push({ name: 'serviceSheetDetails', query: { refId } })
    },
    onLoad () {
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getOrderList(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 500)
    },
    async getOrderList (pageNum) {
      const res = await this.$axios.get(`api/refund/list/103/${pageNum}`)
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.orderRecords = [...this.orderRecords, ...data]
        } else if (code === 9006) {
          if (pageNum === 1) {
            this.noData = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.order-list {
  padding: 0 0.2rem;
  background-color: #fff;
}
.sku-details {
  padding: 0.38rem 0 0.16rem;
  border-bottom: 0.5px solid #dadada;
  .service-ticket {
    font-size: @fz24;
    color: @base;
    padding-bottom: 0.26rem;
    .flex-between;
    .service-number {
      width: 5rem;
      .ellipsis;
    }
  }
  .jump-details {
    display: flex;
    justify-content: space-between;
  }
  .sku-img {
    width: 2rem;
    height: 2rem;
  }
  .sku-desc {
    padding-right: 0.33rem;
  }
  .sku-intro {
    width: 4.5rem;
    height: 2rem;
    .flex-column-between;
    margin-left: 0.2rem;
    .sku-title {
      width: 3.03rem;
      .ellipsis2;
      font-size: @fz24;
      color: @base;
    }
    .sku-name-num {
      .flex-between;
      .sku-name {
        max-width: 3.03rem;
        font-size: @fz20;
        color: @sku-name;
        background-color: #f5f5f5;
        border: 0.5px solid #cbcbcb;
        border-radius: 0.04rem;
        .ellipsis;
        span {
          padding: 0.05rem 0.1rem;
        }
      }
      .sku-num {
        font-size: @fz24;
        color: @base;
      }
    }
    .sku-platform {
      font-size: @fz24;
      color: @c80;
    }
  }
  .service-status {
    padding: 0.28rem 0 0.16rem;
    padding-right: 0.23rem;
    text-align: right;
    color: @base;
    font-size: 0.24rem;
  }
}
</style>
